import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=627ebfd7&scoped=true&"
import script from "./ContentDetail.vue?vue&type=script&lang=js&"
export * from "./ContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=627ebfd7&prod&lang=scss&"
import style1 from "./ContentDetail.vue?vue&type=style&index=1&id=627ebfd7&prod&lang=scss&scoped=true&"
import style2 from "./ContentDetail.vue?vue&type=style&index=2&id=627ebfd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ebfd7",
  null
  
)

export default component.exports